import {
  MenuItemCheckedContext
} from "../__chunks/HVBRRKV4.js";
import {
  useCheckboxCheck
} from "../__chunks/37OBPWF6.js";
import "../__chunks/M5KYRTQG.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/NQJBHION.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "../__chunks/PNRLI7OV.js";

// src/menu/menu-item-check.ts
import { useContext } from "react";
var useMenuItemCheck = createHook(
  (_a) => {
    var _b = _a, { store, checked } = _b, props = __objRest(_b, ["store", "checked"]);
    const context = useContext(MenuItemCheckedContext);
    checked = checked != null ? checked : context;
    props = useCheckboxCheck(__spreadProps(__spreadValues({}, props), { checked }));
    return props;
  }
);
var MenuItemCheck = createComponent((props) => {
  const htmlProps = useMenuItemCheck(props);
  return createElement("span", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  MenuItemCheck.displayName = "MenuItemCheck";
}
export {
  MenuItemCheck,
  useMenuItemCheck
};
